<template>
    <div>
        <div class="colors-section"
            @mouseover="handleColorsInteraction" 
            @mouseleave="handleColorsInteraction"    
        >
            <span class="colors__title">Cores:</span>
            <div class="color" :style="{ backgroundColor: data.primaryColor }"></div>  
            <div class="color" :style="{ backgroundColor: data.secondaryColor }"></div>  
            <div class="color" :style="{ backgroundColor: data.tertiaryColor }"></div>  
            <transition name="fade">
                <div class="edit-box edit-box--colors" @click="handleColorsInteraction" v-if="showEditColorsButton || selectedSectionToEdit === 'colors'">
                    <i class="edit-icon">
                        <EditIcon />
                    </i>
                </div>
            </transition> 
        </div>

        <div>
            <table class="email-layout" id="email-layout" 
                   border="0" 
                   align="center" 
                   cellpadding="0" 
                   cellspacing="0" 
                   width="100%" 
                   style="font-family: helvetica; 
                          max-width: 600px;"
            >
                <tr>
                    <td>
                        <table border="0" 
                               align="center" 
                               cellpadding="0" 
                               cellspacing="0">
                            <tr>
                                <td>
                                    <tr class="logo-section" 
                                        :style="{ 
                                            backgroundColor: data.primaryColor 
                                        }"
                                    >
                                        <td align="center" 
                                            style="padding: 20px; 
                                                   text-align: center;"
                                        >
                                            <img :src="data.logoImageUrl" alt="Logo Atlas">
                                        </td>
                                    </tr>

                                    <tr class="description-section"
                                        @mouseover="handleDescriptionSectionInteraction" 
                                        @mouseleave="handleDescriptionSectionInteraction"
                                        :style="{
                                            backgroundColor: '#fff',
                                            position: 'relative',
                                            textAlign: 'center'
                                        }"
                                    >
                                        <td style="text-align: center; 
                                                padding: 20px;"
                                        >
                                            <h2 class="section__title" 
                                                :style="{
                                                    color: data.primaryColor, 
                                                    padding: '10px 50px',
                                                    fontSize: '30px', 
                                                    fontStyle: 'italic',
                                                    textAlign: 'center',
                                                    textTransform: 'uppercase',
                                                    margin: '0',
                                                    fontWeight: '700',
                                                }"
                                            >
                                                {{ data.descriptionSection.title }}
                                            </h2>
                                            <h1
                                                :style="{
                                                    color: data.primaryColor, 
                                                    padding: '10px 50px',
                                                    textAlign: 'center',
                                                    textTransform: 'uppercase',
                                                    margin: '0',
                                                    fontWeight: '700',
                                                }"
                                            >
                                                {{ data.descriptionSection.subtitle }}
                                            </h1>
                                            <a :href="data.descriptionSection.button.link" target="_blank" class="button"
                                               :style="{
                                                            backgroundColor: '#fff',
                                                            color: data.tertiaryColor,
                                                            padding: '6px 20px',
                                                            border: 'solid 2px '+data.tertiaryColor,
                                                            borderRadius: '50px',
                                                            fontSize: '20px',
                                                            fontStyle: 'italic',
                                                            fontWeight: '600',
                                                            textAlign: 'center',
                                                            marginBottom: '20px',
                                                            marginTop: '10px',
                                                            textDecoration: 'none'
                                                        }">
                                                {{ data.descriptionSection.button.text }}
                                            </a>
                                        </td>
                                        <transition name="fade">
                                            <div class="edit-box" 
                                                @click="handleDescriptionSectionInteraction" 
                                                v-if="showEditDescriptionSectionButton || selectedSectionToEdit === 'descriptionSection'"
                                            >
                                                    <i class="edit-icon">
                                                        <EditIcon />
                                                    </i>
                                            </div>
                                        </transition>
                                    </tr>

                                    <tr class="banner-section" 
                                        @mouseover="handleBannerSectionInteraction" 
                                        @mouseleave="handleBannerSectionInteraction"
                                    >
                                        <td>
                                            <img :src="data.bannerSection.image.url" 
                                                 :alt="data.bannerSection.image.alt" 
                                                 style="width: 100%; 
                                                        object-fit: cover; 
                                                        display: block;
                                                        maxHeight: 400px;"
                                            >
                                        </td>
                                        <transition name="fade">
                                            <div class="edit-box" 
                                                @click="handleBannerSectionInteraction" 
                                                v-if="showEditBannerSectionButton || selectedSectionToEdit === 'bannerSection'"
                                            >
                                                <i class="edit-icon">
                                                    <EditIcon />
                                                </i>
                                            </div>
                                        </transition>
                                    </tr>

                                    <tr class="video-section"
                                        @mouseover="handleVideoSectionInteraction" 
                                        @mouseleave="handleVideoSectionInteraction"
                                    >
                                        <td style="
                                            padding: 40px 0 40px 0;
                                            background: #fff"
                                        >
                                            <table>
                                                <tr>
                                                    <td style="
                                                        width:50%;
                                                        text-align: right;
                                                        vertical-align: top;
                                                        padding: 0 10px;
                                                    ">
                                                        <h4 :style="{
                                                            width: '100%',
                                                            height: '100%',
                                                            display:'block',
                                                            margin: 'auto',
                                                            fontStyle: 'italic',
                                                            fontWeight: 700,
                                                            color: data.primaryColor
                                                        }">{{data.videoSection.title}}</h4>
                                                        <p class="product-item__decription" 
                                                            style="color: #333;
                                                            fontSize: 14px;
                                                            font-weight:500;
                                                            margin-top: 4px;
                                                            "
                                                        >
                                                            {{data.videoSection.text}}
                                                        </p>
                                                    </td>
                                                    <td style="max-width:50%; padding: 0 10px;">
                                                        <a :href="data.videoSection.link">
                                                            <div style="
                                                                width:100%;
                                                                heigth:100%;
                                                                margin: 0 auto;
                                                                max-height: 1px;
                                                            ">
                                                                <img height="167" 
                                                                    style="width: 100%;
                                                                        object-fit: cover;
                                                                        display: block;"
                                                                    :src="data.videoSection.image.url" 
                                                                    :alt="data.videoSection.image.alt" 
                                                                >
                                                            </div>
                                                            <img style=" object-fit: cover; position:relative; opacity:0.999;" :src="appRoot + '/public/images/news-personalizada/play-video.png'" alt="Play vídeo">
                                                        </a>

                                                    </td>
                                                </tr>
                                            </table>
                                              <transition name="fade">
                                                <div class="edit-box" 
                                                    @click="handleVideoSectionInteraction" 
                                                    v-if="showEditVideoSectionButton || selectedSectionToEdit === 'videoSection'"
                                                >
                                                    <i class="edit-icon">
                                                        <EditIcon />
                                                    </i>
                                                </div>
                                            </transition>
                                        </td>
                                    </tr>

                                    <tr class="products-list-section" 
                                        @mouseover="handleProductsListSectionInteraction" 
                                        @mouseleave="handleProductsListSectionInteraction"
                                    >
                                        <td style="padding: 0;
                                                background-color: #fff;"
                                        >
                                            <tr>
                                                <table style="border-spacing: 0 20px;">
                                                    <tr class="products-list-section__product-item" 
                                                        v-for="(product, index) in data.productsListSection.productsList" :key="product.id"
                                                        style="vertical-align: top;"
                                                    >
                                                        <td v-if="product.id % 2 !== 0"
                                                            class="product-item__image" 
                                                            style="width: 50%;
                                                                   padding: 30px 10px 30px 10px;
                                                                   margin-bottom: 30px;
                                                                   border-bottom: 1px solid lightgrey;" 
                                                            :style="{
                                                                width: '50%',
                                                                padding: index === 0 ? '10px 10px 30px 10px' : '30px 10px 30px 10px',
                                                                marginBottom: '30px',
                                                                borderBottom: '1px solid lightgrey',
                                                            }"   
                                                        >
                                                            <img :src="product.image.url" 
                                                                :alt="product.image.alt"
                                                                style="width: 100%;
                                                                        object-fit: cover;
                                                                        display: block;
                                                                        border-radius: 5px;"
                                                            >
                                                        </td>
                                                        <td class="product-item__data" 
                                                            width="50%"                                                          
                                                            :style="{
                                                                textAlign: product.id % 2 !== 0 ? 'left' : 'right', 
                                                                padding: index === 0 ? '10px 10px 30px 10px' : '30px 10px 30px 10px',
                                                                borderBottom: '1px solid lightgrey'
                                                            }"
                                                        > 
                                                            <div>
                                                                <h3 class="product-item__name" 
                                                                    :style="{
                                                                        color: data.primaryColor,
                                                                        fontWeight: '600',
                                                                        textTransform: 'uppercase',
                                                                        fontSize: '18px',
                                                                        margin: '0 0 7px 0', 
                                                                        padding: '0',
                                                                        backgroundColor: '#fff',
                                                                        width: '100%'
                                                                    }">
                                                                    {{ product.productData.name }}
                                                                </h3>
                                                                <h4 class="product-item__code" 
                                                                    :style="{
                                                                        color: data.primaryColor,
                                                                        fontWeight: '600',
                                                                        textTransform: 'uppercase',
                                                                        fontSize: '16px',
                                                                        margin: '0 0 10px 0',
                                                                    }">
                                                                    {{product.productData.code}}
                                                                </h4>
                                                            </div>
                                                            <p class="product-item__decription" 
                                                            style="color: #333;
                                                                    fontSize: 14px;"
                                                            >
                                                                {{product.productData.description}}
                                                            </p>
                                                            <a class="product-item__link" 
                                                                :href="product.productData.link.url"
                                                                target="_blank"
                                                                :style="{
                                                                    color: data.secondaryColor,
                                                                    textDecoration: 'none',
                                                                    textTransform: 'uppercase',
                                                                    fontWeight: '600',
                                                                    fontSize: '18px',
                                                                }"
                                                            >
                                                                {{product.productData.link.text}}
                                                            </a>
                                                        </td>
                                                        <td v-if="product.id % 2 === 0"
                                                            class="product-item__image" 
                                                            style="width: 50%;
                                                                   padding: 30px 10px 30px 10px;
                                                                   border-bottom: 1px solid lightgrey;"    
                                                        >
                                                            <img :src="product.image.url" 
                                                                :alt="product.image.alt"
                                                                style="width: 100%;
                                                                        object-fit: cover;
                                                                        display: block;
                                                                        border-radius: 5px;"
                                                            >
                                                        </td>
                                                    </tr>
                                                </table>
                                            </tr>
                                            <transition name="fade">
                                                <div class="edit-box" 
                                                    @click="handleProductsListSectionInteraction" 
                                                    v-if="showEditProductsListSectionButton || selectedSectionToEdit === 'productsListSection'"
                                                >
                                                    <i class="edit-icon">
                                                        <EditIcon />
                                                    </i>
                                                </div>
                                            </transition>
                                        </td>
                                    </tr>

                                    <tr class="bottom-text"
                                        @mouseover="handleBottomSectionInteraction" 
                                        @mouseleave="handleBottomSectionInteraction"
                                    >
                                        <td style="
                                            padding: 60px 0 40px 0;
                                            background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(219,242,252,1) 64%, rgba(181,229,250,1) 93%, rgba(147,217,247,1) 100%);"
                                        >
                                            <table>
                                                <tr>
                                                    <td style="
                                                        width:50%;
                                                        text-transform: uppercase;
                                                        text-align: right;
                                                        padding: 0 10px;
                                                        vertical-align: middle;
                                                    ">
                                                        <h2 :style="{
                                                            width: '100%',
                                                            height: '100%',
                                                            display:'block',
                                                            margin: 'auto',
                                                            fontWeight: 700,
                                                            color: data.primaryColor
                                                        }">{{data.bottomSection.text}}</h2>
                                                    </td>
                                                    <td style="width:50%; padding: 0 10px;">
                                                        <div style="
                                                            width:100%;
                                                            heigth:100%;
                                                            display:inline-block
                                                        ">
                                                            <a :href="data.bottomSection.link">
                                                                <img 
                                                                    style="width: 100%;
                                                                        object-fit: cover;
                                                                        display: block;"
                                                                    :src="data.bottomSection.image.url" 
                                                                    :alt="data.bottomSection.image.alt"
                                                                >
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                            <transition name="fade">
                                                <div class="edit-box" 
                                                    @click="handleBottomSectionInteraction" 
                                                    v-if="showEditBottomSectionButton || selectedSectionToEdit === 'BottomSection'"
                                                >
                                                    <i class="edit-icon">
                                                        <EditIcon />
                                                    </i>
                                                </div>
                                            </transition>
                                        </td>
                                    </tr>

                                    <tr class="footer-section"
                                        :style="{
                                            backgroundColor: data.primaryColor,
                                            width: '100%',
                                            maxWidth: '600px',
                                            color: '#fff',
                                        }"
                                    >
                                        <td>
                                            <table width="100%">           
                                                <tr style="font-size: 14px;">
                                                    <td width="75%"
                                                        style="padding: 20px 10px;
                                                               min-width: 125px;"
                                                    >
                                                        <div class="social-links">
                                                            <a v-for="socialLink in socialLinks" :key="socialLink.index" href="https://pt-br.facebook.com/pinceisatlasoficial/" target="_blank">
                                                                <img :src="socialLink.imageUrl" 
                                                                     :alt="socialLink.alt"
                                                                     style="height: 25px; 
                                                                            width: 25px;
                                                                            margin-right: 10px;"
                                                                >
                                                            </a>

                                                            <span style="vertical-align: middle;">
                                                                /pinceisatlasoficial |
                                                                <a href="https://www.pinceisatlas.com.br" 
                                                                   target="_blank" 
                                                                   style="color: #fff; 
                                                                          text-decoration: none;"
                                                                >
                                                                    www.pinceisatlas.com.br
                                                                </a>
                                                            </span>
                                                        </div> 
                                                    </td>               
                                                    <td width="25%" align="right">
                                                        <img :src="data.logoImageUrl" alt="Logo Atlas" style="object-fit: contain; width: 130px;">
                                                    </td>
                                                </tr>
                                                                
                                            </table>
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import EditIcon from '../../../icons/edit-icon.vue'

export default {
    name: 'CLayout2',
    components: { EditIcon },
    props: { 
        data: Object,
        selectedSectionToEdit: String,
    },
    data() {
        return {
            selectedSection: this.selectedSectionToEdit,
            showEditColorsButton: false,
            showEditBannerSectionButton: false,
            showEditDescriptionSectionButton: false,
            showEditProductsListSectionButton: false,
            showEditBottomSectionButton: false,
            showEditVideoSectionButton: false,
            appRoot: _ROOT_PATH,
            socialLinks: [
                {
                    imageUrl: _PUBLIC_PATH + '/images/news-personalizada/icon-facebook.png',
                    alt:'Ícone do Facebook',
                    link: 'https://pt-br.facebook.com/pinceisatlasoficial/'
                },
                {
                    imageUrl: _PUBLIC_PATH + '/images/news-personalizada/icon-instagram.png',
                    alt:'Ícone do Instagram',
                    link: 'https://www.instagram.com/pinceisatlasoficial/'
                },
                {
                    imageUrl: _PUBLIC_PATH + '/images/news-personalizada/icon-youtube.png',
                    alt:'Ícone do Youtube',
                    link: 'https://pt-br.facebook.com/pinceisatlasoficial/',
                },
            ]
        }
    },
    watch: {
            selectedSection() {
                this.emitSelectedSection()
            }
        },
    methods: {
        emitSelectedSection() {
            this.$emit('update:selectedSectionToEdit', this.selectedSection)
        },
        handleColorsInteraction(event) {
            if (event.type === 'mouseover') {
                this.showEditColorsButton = true
            } else if (event.type === 'mouseleave') {
                this.showEditColorsButton = false
            } else if (event.type === 'click') {
                this.selectedSection = 'colors'
            }           
        },
        handleBannerSectionInteraction(event) {
            if (event.type === 'mouseover') {
                this.showEditBannerSectionButton = true
            } else if (event.type === 'mouseleave') {
                this.showEditBannerSectionButton = false
            } else if (event.type === 'click') {
                this.selectedSection = 'bannerSection' 
            }            
        },
        handleDescriptionSectionInteraction(event) {
            if (event.type === 'mouseover') {
                this.showEditDescriptionSectionButton = true
            } else if (event.type === 'mouseleave') {
                this.showEditDescriptionSectionButton = false
            } else if (event.type === 'click') {
                this.selectedSection = 'descriptionSection'
            }            
        },
        handleProductsListSectionInteraction(event) {
            if (event.type === 'mouseover') {
                this.showEditProductsListSectionButton = true
            } else if (event.type === 'mouseleave') {
                this.showEditProductsListSectionButton = false
            } else if (event.type === 'click') {
                this.selectedSection = 'productsListSection'
            }            
        },
        handleBottomSectionInteraction(event) {
            if (event.type === 'mouseover') {
                this.showEditBottomSectionButton = true
            } else if (event.type === 'mouseleave') {
                this.showEditBottomSectionButton = false
            } else if (event.type === 'click') {
                this.selectedSection = 'bottomSection'
            }            
        },
        handleVideoSectionInteraction(event) {
            if (event.type === 'mouseover') {
                this.showEditVideoSectionButton = true
            } else if (event.type === 'mouseleave') {
                this.showEditVideoSectionButton = false
            } else if (event.type === 'click') {
                this.selectedSection = 'videoSection'
            }            
        },
    }
}
</script>

<style src="../../style.scss" lang="scss" scoped></style>